/* istanbul ignore file */
export class GetUserDefaultUoM {
  static readonly type = '[UoM] Get User Preferred UoM'
}

export class GetStandardUoM {
  static readonly type = '[UoM] Get Standard UoM'
}

export class GetUoMConversions {
  static readonly type ='[UoM] Get UoM Conversion'
}

export class GetUoMConversionDetails {
  static readonly type = '[UoM] Get Conversion Details'
}

export class GetUoMDependencies {
  static readonly type = '[UoM] Get UOM Dependencies'
}